import api from '../config/api';

import * as LocalStorageService from './LocalStorageService';

export const addAccount = clientNumber =>
  api.post('api/v1/accounts', { account: { client_number: clientNumber } });

export const getAccountsAsync = async (briefData, pageNumber, pageSize) =>
  api.get('api/v1/accounts/async', { page: pageNumber, page_size: pageSize, brief_data: briefData });

export const getCurrentAccount = (user, accounts) => {
  const currentAccountId = LocalStorageService.getCurrentAccountId(user);
  let currentAccount = accounts.find(account => account.id === currentAccountId);
  if (!currentAccount) {
    [currentAccount] = accounts;
    LocalStorageService.setCurrentAccountId(currentAccount.id, user);
  }

  return currentAccount;
};

export const getPositiveCreditStatusQuality = async clientNumber =>
  api.get(`api/v1/accounts/pending_fine_amount?client_number=${clientNumber}`);

export const getPositiveCreditStatusWarranty = async clientNumber =>
  api.get(`api/v1/accounts/pending_guarantee_deposit?client_number=${clientNumber}`);

export const getAccountAsync = accountId =>
  api.get(`api/v1/accounts/${accountId}/async`, {
    account_id: accountId
  });

export const getAccountAlerts = accountId => api.get(`/api/v1/accounts/${accountId}/alerts`);

export const setCurrentAccount = (user, account) => LocalStorageService.setCurrentAccountId(account.id, user);

export const deleteAccount = accountId => api.delete(`api/v1/accounts/${accountId}/async`, { id: accountId });

export const getTermsAndConditions = () => api.get('api/v1/utilities/terms_and_conditions');

export const getRelatedAccounts = clientNumber =>
  api.get(`api/v1/accounts/related?client_number=${clientNumber}`);

export const getQuestions = clientNumber =>
  api.get(`api/v1/accounts/validation_questions?client_number=${clientNumber}`);

export const postRelatedAccounts = accountList =>
  api.post('api/v1/accounts/multiple_association', { client_numbers: accountList });

export const validateSocialRate = accountId =>
  api.get('api/v1/accounts/social_rate_validation', { client_number: accountId });

export const getAccountBalance = (clientNumber, email) =>
  api.get('api/v1/accounts/balance', { client_number: clientNumber, email });

export const getTermsOfService = service => api.get(`api/v1/services/${service}/terms_and_conditions`);

export const acceptServiceAgreement = (service, accounts) =>
  api.post(`api/v1/services/${service}/agreement`, {
    client_numbers: accounts
  });

export const evaluateChangeExpirationDate = async () => api.get('api/v1/procedures/billing_due_date');

export const changeExpirationDate = async (startDay, endDay) =>
  api.put('api/v1/procedures/billing_due_date', {
    expiration_start_day: startDay,
    expiration_end_day: endDay
  });
